export default __webpack_public_path__ + "static/center-jp-426c65ff610da1f1f704b93e36deddf1.webp";